<div id="map-container" style="width: 100%; height: 100%;"></div>
